import { Injectable } from '@angular/core';

/**
 * Counts swipers on the page. Create a unique number ID for a swiper instance
 */
@Injectable({
    providedIn: 'root',
})
export class SwiperCounterService {
    private numbers: number[] = [];

    /**
     * Get swiper Counter ID
     */
    get id(): number {
        const id = Math.max(...this.numbers);
        this.numbers.push(id);
        return id;
    }

    /**
     * Removes specific swiper unique Id
     */
    remove(id: number): void {
        this.numbers.splice(this.numbers.indexOf(id), 1);
    }
}
